import { useNavigate } from "react-router-dom";

// components
import { Button } from "@mui/material";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import StatusPage from "../components/StatusPage";

// icons

const NotFound = () => {
  // hooks
  const navigate = useNavigate();

  return (
    <StatusPage
      icon={<TravelExploreIcon />}
      title="Page not found"
      actions={
        <Button variant="contained" onClick={() => navigate("/")}>
          Go to Swap
        </Button>
      }
    >
      The link may be broken or the page may have moved.
    </StatusPage>
  );
};

export default NotFound;
